import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
} from '@angular/core';
import { AuthService } from '@klickdata/core/auth';
import { AiModelSpecs, MaterialModelType } from '@klickdata/core/resource/src/resource.model';
import { Utils } from '@klickdata/core/util';

@Component({
    selector: 'app-ai-model-selector',
    templateUrl: './ai-model-selector.component.html',
    styleUrls: ['./ai-model-selector.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AiModelSelectorComponent implements OnInit {
    @Input() multipleCheck: boolean = false;
    @Input() set aiModelType(value: MaterialModelType) {
        this.onUpdateModelType(value);
    }

    model: AiModelSpecs = null;
    @Output() modelChange = new EventEmitter<AiModelSpecs>();
    public allLLmsList: AiModelSpecs[];

    constructor(protected auth: AuthService, protected cdr: ChangeDetectorRef) {}

    ngOnInit(): void {
        if (!this.allLLmsList) {
            this.onUpdateModelType(MaterialModelType.TEXT);
        }
    }

    selectModel(value: AiModelSpecs): void {
        this.model = value;
        this.modelChange.emit(value);
    }

    private onUpdateModelType(aiModelType: MaterialModelType): void {
        this.allLLmsList = this.getAllModelList(aiModelType);
        this.model = this.allLLmsList.find((item) => item.default);
        this.modelChange.emit(this.model);
        this.cdr.detectChanges();
    }

    private getAllModelList(aiModelType: MaterialModelType): AiModelSpecs[] {
        const modelMap = {
            [MaterialModelType.TEXT]: () => Utils.getLLmsList(),
            [MaterialModelType.IMAGE]: () => Utils.getImageLLmsList(),
            [MaterialModelType.VIDEO]: () => Utils.getVideoLLmsList(),
            [MaterialModelType.AUDIO]: () => Utils.getAudioLLmsList(),
        };
        return modelMap[aiModelType]();
    }
}
